import React, { useReducer, useState, useEffect} from 'react';
import OrderItem from './OrderItem'
import AutoSuggestInput from '../../shared/components/formElements/AutoSuggestInput'
import Dropdown from '../../shared/components/formElements/DropDown'
import Card from '../../shared/components/UIElements/Card'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import './OrderList.css'
import { ERRORS } from './CustomerOrderList'

export const ACTIONS = {
    ADD_ORDER_ITEM: "add-orderItem",
    DELETE_ORDER_ITEM: 'delete-orderItem',
    INIT_ORDER_ITEM: 'init-orderItem'
  }

  const reducer = (orderItems, action) => {
    switch (action.type) {
        case ACTIONS.ADD_ORDER_ITEM:
            if (newOrderItem(
                action.payload.newItem, 
                orderItems, 
                action.payload.dropdownvalue,
                action.payload.discountValue                
                )) {
                    return [...orderItems, newOrderItem(
                        action.payload.newItem, 
                        orderItems, 
                        action.payload.dropdownvalue,
                        action.payload.discountValue
                        )] 
            } else {
                action.payload.newItem.length === 0 ?
                    action.payload.seError(ERRORS.ITEM_NOT_FOUND) :
                    action.payload.seError(ERRORS.ITEM_ALREADY_EXIST)
                return [...orderItems]
            }
        case ACTIONS.DELETE_ORDER_ITEM:
            return orderItems.filter(orderItem => orderItem.id !== action.payload.id)
        case ACTIONS.INIT_ORDER_ITEM:
            return action.payload ? action.payload  : orderItems
      default:
        return orderItems
    }
  }

  const checkExistingItemsHandler = (orderItems, newItem) => {
    const existingId = orderItems.map(order => order.id);
    return existingId.includes(newItem[0].id)
  }

  const newOrderItem = (newItem, orderItems, quantity, discount) => { 
   
    if (newItem.length > 0 && 
        !checkExistingItemsHandler(orderItems, newItem) &&
        Number(quantity) > 0 &&
        Number(discount) >= 0       
        ) {
        return { 
            id: newItem[0].id, 
            style: newItem[0].style,
            USSize: newItem[0].USSize,
            EURSize: newItem[0].EURSize,
            color: newItem[0].color,
            company: newItem[0].company,
            price: newItem[0].price,
            quantity: Number(quantity),
            discount: Number(discount),
            type: newItem[0].type
        }
    }
    return false;
  }

  const OrderList = ({suggestionArray, id, onInput, type, deposit , tax, initialItems}) => {

    const [orderItems, dispatch] = useReducer(reducer, [])
    const [style, setStyle] = useState('');
    const [msg, setMsg] = useState();

    useEffect( () => {
        dispatch({
            type: ACTIONS.INIT_ORDER_ITEM, 
            payload: initialItems
       });
    }, [])
    
    const handleSubmit = (event) => {
        event.preventDefault();
        const newItem = suggestionArray.filter(item => item.style === style)
        dispatch({
             type: ACTIONS.ADD_ORDER_ITEM, 
             payload: {
                style: style,
                newItem: newItem,
                dropdownvalue: dropdownvalue,
                discountValue: discountValue,
                seError: setMsg,
            }
        });
        setStyle('');
        setOption([]);
        setDropdownvalue('1');
        setDiscountValue(0);
    }

    const suggestion = suggestionArray.filter(item => {
        return item.quantity > 0
    }).map(item => {
        return(
          {
            name: item.style,
            itemId: item.id,
          }
        )
      })
    const onChange = (event, { newValue }) => {
        setStyle(newValue);
        const styleList = suggestionArray.map(item => [item.style, item.quantity]);
        const qty = styleList.some(pair => pair[0] === newValue) ? 
            styleList.filter(pair => pair[0] === newValue).flat()[1]:
            0;
        if (qty > 0) {
            updateOptions(Array.from({length: qty}, (_, index) => index + 1)); 
        } else{
            updateOptions([])
        }       
    };

    useEffect(() => {
        onInput(id, orderItems, orderItems.length !== 0)
    }, [id, orderItems, onInput]);

    const updateOptions = (range) => {
        setOption(range.map(val => ({ label: String(val), value: val})))
    }

    const [dropdownvalue, setDropdownvalue] = useState('1');
    const [options, setOption] = useState([]);
    const [discountValue, setDiscountValue] = useState(0);
    const handleDropdownChange = (event) => {
        setDropdownvalue(event.target.value);
    };
    let SUBTOTAL = 0;
    let DISCOUNT = 0;
    let SALES_TAX = 0;

    return (
        <>
            {msg && <ErrorModal error={msg} onClear={() => setMsg(null)} />}
            <div className="item-container">
                <div className="item-input" style={{maxWidth:"250px"}}>
                <label htmlFor="name" className="f6 b db mb2">Item <span className="normal black-60"></span></label>
                    <AutoSuggestInput
                        type={type}
                        onChange={onChange}
                        suggestionArray= {suggestion}
                        inputValue={style} 
                        placeholder="Add an item"
                     />
                </div>

                <div className="item-quantity">
                    <Dropdown
                        label="Quantiy: "
                        options={options}
                        value={dropdownvalue}
                        onChange={handleDropdownChange}
                        placeholder="Select an option"
                    />
                </div>
                <div className="item-discount">
                    <label className="discount-label"><span style={{fontWeight:"bold"}}>Discount: %{discountValue}</span></label>
                        <input 
                            value={discountValue}
                            type="range"
                            id="discount" 
                            name="discount" 
                            min="0" 
                            max="35"
                            step="5"
                            onChange={event => setDiscountValue(event.target.value) }
                            className="discount-slider"
                        />                  
                </div>
                <div className="item-add">
                     <button className={`${style.length > 0 && "add-button-glow "} add-button`} onClick={handleSubmit}>ADD</button>
                </div>
         
            </div>
            <div>
          </div>  
            <table className="customer-table">
                <tbody>
                    <tr className="customer-table-thead">
                        <th>Style#</th>
                        <th>Company</th>
                        <th>Color</th>
                        <th>US Size</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Discount</th>
                        <th>Amount</th>
                        <th>Cancel</th>
                    </tr>      
                    {         
                        orderItems.map((orderItem) => {
                            return <OrderItem key={orderItem.id} orderItem={orderItem} dispatch={dispatch}/>
                        })
                    }
                </tbody>
            </table>
            <div className="total">
              
                <Card className="total-card">
                    <div className="column-total-card">
                        <span className="post-total">SUBTOTAL<br/></span>
                        <span className="post-total">DISCOUNT<br/></span>
                        <span className="post-total">SALES TAX<br/></span>
                        {deposit && deposit !== "0" && <span className="post-total">DEPOSIT<br/></span>}
                        <br/>
                        BALANCE
                    </div>
                    <div className="column-total-card">
                    <span className="post-total">                     
                        $<div className="sub-total-card">
                        {    
                            (SUBTOTAL += orderItems.reduce((acc, item) => {
                                return acc + item.price * item.quantity
                            }, 0)).toFixed(2)
                        }
                        </div>
                    </span>
                    </div>
                    <div className="column-total-card">
                    <span className="post-total">
                        $<div className="sub-total-card">
                        {    
                            (DISCOUNT += orderItems.reduce((acc, item) => {
                                return acc + item.price * item.quantity * (item.discount) / 100
                            }, 0)).toFixed(2)
                        }
                        </div>
                    </span>
                    </div>
                    

                    <div className="column-total-card">
                    <span className="post-total">
                        $<div className="sub-total-card">
                            {    
                                tax==="on" ? (SALES_TAX += (SUBTOTAL - DISCOUNT) * 9.5 / 100).toFixed(2) :
                                (0).toFixed(2)
                            }
                        </div>
                    </span>
                    </div>
                
                    {deposit && deposit !== "0" &&
                        <div className="column-total-card">
                        <span className="post-total">
                            $<div className="sub-total-card">
                                {    
                                    Number(deposit).toFixed(2)
                                }
                            </div>
                        </span>
                        </div>
                    }
                    <div className="column-total-card" >
                    <br/>
                    <span className="post-total"></span>
                        $<div className="sub-total-card">                  
                            {    
                                (SUBTOTAL - DISCOUNT + SALES_TAX - Number(deposit)).toFixed(2)
                            }
                        </div>
                    </div>
                </Card>
     
            </div>
        </>
    )
  }

  export default OrderList;